// extracted by mini-css-extract-plugin
export default {"root":"SpinHeader_root__pzKTO","logo":"SpinHeader_logo__bDKYC","tagline":"SpinHeader_tagline__KkXSv"};